import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-merchant-chargebacks',
  templateUrl: './merchant-chargebacks.component.html',
  standalone: false,
})
export class MerchantChargebacksComponent {
  @Input() merchantId: string | undefined;

  constructor() {}
}
